import { AppBar, Button, Toolbar } from '@mui/material';
import logo from '../assets/logo.png';
import switchIcon from '../assets/switch.png';
import switchIcon2 from '../assets/switch2.png';
import { overlayButtonSx } from './overlayButtonSx';

const AppBarOverlay = ({
    oppsShownButtonAction,
    navigateTo,
    oppShown,
}: {
    oppsShownButtonAction: () => void
    navigateTo: () => void
    oppShown: { state: string }
}) => {
    const oppsShownLogo = oppShown?.state === "tagged" ? switchIcon : switchIcon2;
    const label = oppShown?.state === "tagged" ? "Tagged" : "Created";

    return (
        <AppBar position="static" style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}>
            <Toolbar
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: 8,
                    minHeight: 56,
                    paddingLeft: 8,
                    paddingRight: 8,
                }}
            >
                <Button
                    onClick={navigateTo}
                    variant="text"
                    color="inherit"
                    aria-label="Open settings"
                    sx={{ ...overlayButtonSx, minWidth: 0, flexShrink: 0 }}
                >
                    <img src={logo} alt="YouCould" style={{ height: 40, width: 'auto', maxWidth: '40vw' }} />
                </Button>
                <Button
                    onClick={oppsShownButtonAction}
                    variant="text"
                    color="inherit"
                    startIcon={<img src={oppsShownLogo} alt="" style={{ maxHeight: 22, width: 'auto' }} />}
                    sx={{
                        ...overlayButtonSx,
                        fontSize: '1.05rem',
                        fontWeight: 700,
                        minWidth: 0,
                        textTransform: 'capitalize',
                    }}
                >
                    {label}
                </Button>
            </Toolbar>
        </AppBar>
    );
}

export default AppBarOverlay;
